/**
 * safe_code 校验接口（与人机验证页 Vue 项目一致：带 x-app-key / x-timestamp / x-nonce / x-sign）
 */
import axios from "axios";
import MD5 from "blueimp-md5";

const API_BASE = "https://websafeverify-api.beijingfundtown.com";
const VERIFY_URL = "/SafeCode/verifySafeCode";

const APP_KEY = "yunduan_app_key";
const APP_SECRET = "sfjkweo8dfge43hg8wdyum6r24qtvber";

const client = axios.create({
  baseURL: API_BASE,
  timeout: 10000,
});

/**
 * 与人机验证页 buildSignedPayload 一致：生成签名并返回请求头
 * @param {Record<string, any>} bizParams - 业务参数（如 safe_code）
 * @returns {{ params: Record<string, any>, headers: Record<string, string> }}
 */
function buildSignedPayload(bizParams) {
  const timestamp = Math.floor(Date.now() / 1000);
  const nonce = Math.random().toString(36).slice(2) + Date.now();
  const allParams = {
    ...bizParams,
    app_key: APP_KEY,
    timestamp,
    nonce,
  };
  const sortedKeys = Object.keys(allParams).sort();
  const queryStr = sortedKeys.map((k) => `${k}=${allParams[k]}`).join("&");
  const stringToSign = decodeURIComponent(queryStr) + `&app_secret=${APP_SECRET}`;
  const sign = MD5(stringToSign).toUpperCase();
  return {
    params: { ...bizParams },
    headers: {
      "x-app-key": APP_KEY,
      "x-timestamp": String(timestamp),
      "x-nonce": nonce,
      "x-sign": sign,
    },
  };
}

/**
 * 从校验接口返回体里取出业务码（兼容 res.code 与 res.data.code）
 */
export function getVerifyCode(res) {
  if (!res) return undefined;
  if (res.code !== undefined && res.code !== null) return res.code;
  if (res.data && (res.data.code !== undefined && res.data.code !== null)) return res.data.code;
  return undefined;
}

/**
 * 校验 cookie 中的 safe_code 是否有效
 * @param {string} safeCode - 从 cookie 读取的 safe_code（可为空）
 * @returns {Promise<{ code: number, msg?: string, [key]: any }>}
 * 约定：code === 0 表示有效，否则视为无效
 */
export function verifySafeCode(safeCode) {
  const { params, headers } = buildSignedPayload({ safe_code: safeCode || "" });
  return client
    .get(VERIFY_URL, {
      params,
      headers,
    })
    .then((res) => res.data)
    .catch((err) => {
      const data = err.response && err.response.data;
      return data != null ? data : { code: -1 };
    });
}
